import React from 'react';
import { motion } from 'framer-motion';
import { BatteryCharging } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-forest text-offwhite px-6 lg:px-8" data-id="element-166">
      <div className="max-w-4xl mx-auto text-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 border border-white/10 p-10 md:p-16 rounded-3xl" data-id="element-168">
          <BatteryCharging className="mx-auto text-amber mb-8" size={48} data-id="element-169" />
          <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif text-amber" data-id="element-170">
            What changes in 21 days:
          </h2>
          <p className="text-xl md:text-2xl leading-relaxed mb-8 font-serif italic" data-id="element-171">
            "Irritability fades. You stop dragging yourself through the office.
            Your sleep becomes truly restorative because your nervous system
            finally has the minerals it needs to switch off."
          </p>
          <div className="w-24 h-1 bg-amber/50 mx-auto mb-8" data-id="element-172"></div>
          <p className="text-lg text-offwhite/80" data-id="element-173">
            By the end of 3 weeks, you will have established a new energy
            baseline that doesn't depend on anything external.
          </p>
        </motion.div>
      </div>
    </section>;
}